export const environment = {
  production: false,
  api: 'https://test-api-sso.amica.pl/panel',
  upload: 'https://test-api-sso.amica.pl/uploads',
  recaptchaV3SiteKey: '6LfI-RMiAAAAAJ71UXwAJxTYJjE1NYO7cAUjBqm-',
};
